// Per-condo last-selected unit memory (Jaime 2026-09-30 ruling: "it should
// jump to the last one selected" — never the default unit as primary behavior).
// Key includes the condo id; the personal lens uses its own key.

export function lastUnitKey(condoId?: string | null): string {
  return condoId ? `vecindus_last_unit_${condoId}` : 'vecindus_last_unit_personal';
}

export function getLastUnitForCondo(condoId?: string | null): string | undefined {
  try { return localStorage.getItem(lastUnitKey(condoId)) || undefined; } catch { return undefined; }
}

export function setLastUnitForCondo(condoId?: string | null, unitId?: string): void {
  try {
    if (unitId) localStorage.setItem(lastUnitKey(condoId), unitId);
    else localStorage.removeItem(lastUnitKey(condoId));
  } catch { /* storage optional */ }
}

export interface UnitShape { id: string; condo_id?: string | null; }
export interface MembershipShape { unitId?: string; unit_id?: string; condoId?: string | null; condo_id?: string | null; }

/** True when unitId is a unit of condoId (owned unit or membership row). */
export function unitBelongsToCondo(
  unitId: string,
  condoId: string | null | undefined,
  units: UnitShape[],
  membershipRows: MembershipShape[],
): boolean {
  if (condoId) {
    if (units.some((u) => u.id === unitId && u.condo_id === condoId)) return true;
    return membershipRows.some((m) => {
      const mid = m.unitId || m.unit_id;
      if (mid !== unitId) return false;
      return (m.condoId || m.condo_id) === condoId;
    });
  }
  // Personal lens: standalone (unlinked) owned unit or standalone membership.
  if (units.some((u) => u.id === unitId && !u.condo_id)) return true;
  return membershipRows.some((m) => {
    const mid = m.unitId || m.unit_id;
    return mid === unitId && !(m.condoId || m.condo_id);
  });
}
